module.exports = __webpack_public_path__ + "static/media/ImportTemplate.a9110a5f.xlsx";